import { createSlice } from '@reduxjs/toolkit';
import { codebookCodes } from '../constants/codebooks';

let codebooksInitState = {};
Object.keys(codebookCodes).forEach((c) => {
  codebooksInitState[c] = [];
});

const initialState = {
  loading: false,
  error: {},
  codebooks: {
    ...codebooksInitState,
  },
};

const codebooksForFormSlice = createSlice({
  name: 'codebooksForForm',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    fetchCodebooks(state, action) {
      state.codebooks = { ...state.codebooks, ...action.payload };
      state.loading = false;
      state.error = undefined;
    },
    clearCodebooks(state) {
      state.codebooks = initialState.codebooks;
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const codebooksForFormActions = codebooksForFormSlice.actions;

export default codebooksForFormSlice.reducer;
